import formatEuro from '../../../helpers/formatEuro'
import { impactPageUrl } from '../../../helpers/impactInBeeld/impactPageUrl'

/**
 * Document-sectie (kassabon, offerte/factuur): een kopieerbare tekstregel
 * (impactregel + impactpagina-URL) om in het kassasysteem of de offerte-/
 * factuursjabloon te plakken. Automatisch meesturen wacht op de koppeling.
 *
 * @param {object} props
 * @param {string} props.client - Tenant-CompagnyID
 * @param {string} props.orgName - Organisatienaam voor de impactregel
 * @param {number|null} props.ratio - Actueel impact-per-euro-kengetal
 */
const DocumentChannelSection = ({ client, orgName, ratio }) => {
    const url = impactPageUrl({ origin: window.location.origin, client })

    const snippet = ratio !== null
        ? `Elke euro bij ${orgName} = ${formatEuro(ratio)} aan maatschappelijke waarde. Bekijk je impact: ${url}`
        : `Bekijk de maatschappelijke impact van ${orgName}: ${url}`

    return (
        <div className='impact-channel-document-section'>
            <h3>Tekstregel voor je document</h3>
            <p className='impact-channel-snippet'>{snippet}</p>
            <button
                type='button'
                className='impact-in-beeld-add-button'
                onClick={() => navigator.clipboard.writeText(snippet).catch((error) => alert(error))}
            >
                Kopieer tekstregel
            </button>
            <p className='impact-in-beeld-tab-pending'>
                Automatisch meesturen wacht op koppeling: verbind je kassa via de
                Integraties-tab — het API-antwoord bevat de impact per bon. De
                boekhoudkoppeling voor offertes en facturen is in ontwikkeling;
                plak de regel tot die tijd zelf in je sjabloon.
            </p>
        </div>
    )
}

export default DocumentChannelSection
